(function() {
	'use strict';

	angular
		.module('app')

		.controller('ProductsController', ProductsController);

	ProductsController.$inject = ["$timeout", "$location", '$window', 'ProductsService', '$scope'];

	function ProductsController($timeout, $location, $window, ProductsService, $scope) {
		var vm = this;
		vm.loading = true;

		// Estructura de filtros dinámica
		vm.filtros = {};

		// Contador dinámico de filtros activos (excluyendo 'todos')
		vm.contarFiltrosActivos = function() {
			return Object.keys(vm.filtros).reduce(function(total, filtroKey) {
				var filtrosGrupo = vm.filtros[filtroKey] || {};
				var activos = Object.keys(filtrosGrupo)
					.filter(key => key !== 'todos' && filtrosGrupo[key] === true)
					.length;
				return total + activos;
			}, 0);
		};

		// Reset dinámico por filtro
		vm.resetFilters = function(filtroNombre) {

			$timeout(function() {
				vm.filtros[filtroNombre] = { 'todos': true };
				$scope[filtroNombre] = vm.filtros[filtroNombre];
			});
		};

		vm.todosProductosOcultos = function(dis) {
			return dis.products.every(function(prod) {
				return prod.hide == 1;
			});
		};
		vm.actualizarTodos = function(filtroKey) {
			let filtro = vm.filtros[filtroKey];
			let claves = Object.keys(filtro).filter(k => k !== 'todos' && k !== 'campito');
			let seleccionados = claves.filter(k => filtro[k]);

			// Si todos están marcados o ninguno, marcar "todos"
			if (seleccionados.length === 0 || seleccionados.length === claves.length) {
				filtro['todos'] = true;
			} else {
				filtro['todos'] = false;
			}
		};



		vm.toggleTodos = function(filtroKey) {
			let activar = vm.filtros[filtroKey]['todos'];
			Object.keys(vm.filtros[filtroKey]).forEach(k => {
				if (k !== 'todos' && k !== 'campito') {
					vm.filtros[filtroKey][k] = activar;
				}
			});
		};
		vm.resultadosVisibles = function () {
			// if (!vm.disease) return 0;
			let visibles = 0;
			// consocdvdfdle.log(vm.disease.map({a => a.hide}))
			angular.forEach(vm.disease, function (dis) {
				
				if (dis.hide != 1 && !vm.todosProductosOcultos(dis)) {
					// Si no hay texto en el buscador, o el título contiene el texto
					if (!vm.filtros.buscador || (
						dis.title && dis.title.toLowerCase().includes(vm.filtros.buscador.toLowerCase()) || dis.scientificname.toLowerCase().includes(vm.filtros.buscador.toLowerCase()) 
						|| dis.products.some(function(p){
							return p.name.toLowerCase().includes(vm.filtros.buscador.toLowerCase())  || p.skus_id.some(function(s ){
								return s.sku.toLowerCase().includes(vm.filtros.buscador.toLowerCase()); 
							}) 
						})
					)) {
						visibles++;
					}
				}
			});
			return visibles;
		};
		vm.getProducts = function(category_product) {
			ProductsService.getAntigens({
				vm: vm, filtros: vm.filtros, category_parent_id: vm.category_parent_id, category_product: category_product, category_id: vm.category_id, lang_id: vm.lang_id, callback: function(data) {
					vm.loading = false;
					vm.products = data.products;
					vm.disease = data.disease;
					vm.categoryproduct = data.categoryproduct;
					vm.category_id = data.category_id;
					vm.lang_id = data.lang_id;
				}
			});
		};
	}
})();
